import { createSelector } from '@reduxjs/toolkit';
import { groupBy, mapValues } from 'lodash';
import { useSelector } from 'react-redux';

const selectRawPermissions = (state) => state.permissions?.permissions?.permissions;

const selectFormattedPermissions = createSelector([selectRawPermissions], (list = []) => {
  const formatted = list.map(({ groupId, groupName, moduleName, name, hasAccess }) => ({
    groupId,
    formattedGroupName: groupName?.replace(' ', '_'),
    formattedModuleName: moduleName?.replace(' ', '_'),
    name,
    hasAccess,
  }));
  return mapValues(groupBy(formatted, 'formattedGroupName'), (group) =>
    mapValues(groupBy(group, 'formattedModuleName'), (module) => groupBy(module, 'name'))
  );
});

export const usePermissions = () => useSelector(selectFormattedPermissions);

export const usePermissionsStatus = () =>
  useSelector(({ permissions }) => {
    return permissions.status;
  });
